<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->
<template>
  <div class="min-h-screen bg-white">
    <!-- Header -->

    <!-- Main Content -->
    <main class="w-11/12 max-w-full px-4 pt-20 pb-12 mx-auto">
      <!-- Property Grid -->
      <div class="w-full">
        <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          <div v-for="property in properties" :key="property.id"
            class="overflow-hidden transition-shadow bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md">
            <div class="relative h-48">
              <img :src="property.image" :alt="property.title" class="object-cover w-full h-full">
              <span :class="[
                'absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-medium',
                property.status === 'Live' ? 'bg-green-500 text-white' :
                  property.status === 'Upcoming' ? 'bg-blue-500 text-white' : 'bg-gray-500 text-white'
              ]">
                {{ property.status }}
              </span>
            </div>
            <div class="p-4">
              <h3 class="mb-2 font-medium">{{ property.title }}</h3>
              <p class="mb-2 text-sm text-gray-600">
                <i class="mr-1 fas fa-map-marker-alt"></i> {{ property.location }}
              </p>
              <div class="flex items-center gap-4 mb-3 text-sm text-gray-600">
                <span><i class="mr-1 fas fa-bed"></i> {{ property.beds }}</span>
                <span><i class="mr-1 fas fa-bath"></i> {{ property.baths }}</span>
                <span><i class="mr-1 fas fa-ruler-combined"></i> {{ property.sqft }}</span>
              </div>
              <div class="mb-3">
                <div class="text-sm text-gray-600">Starting Bid</div>
                <div class="text-lg font-semibold">${{ property.startingBid }}</div>
              </div>
              <div class="flex items-center justify-between">
                <div class="text-sm text-gray-600">
                  <i class="mr-1 far fa-clock"></i> {{ property.auctionDate }}
                </div>
                <button class="!rounded-button px-4 py-2 bg-blue-600 text-white text-sm hover:bg-blue-700">
                  Bid Now
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <!-- <div class="flex items-center justify-between mt-8">
          <div class="text-sm text-gray-600">Showing 1-9 of 24 properties</div>
          <div class="flex items-center gap-2">
            <button class="!rounded-button px-4 py-2 border text-gray-600 hover:bg-gray-50">Previous</button>
            <button class="!rounded-button px-4 py-2 bg-blue-600 text-white">1</button>
            <button class="!rounded-button px-4 py-2 border text-gray-600 hover:bg-gray-50">2</button>
            <button class="!rounded-button px-4 py-2 border text-gray-600 hover:bg-gray-50">3</button>
            <button class="!rounded-button px-4 py-2 border text-gray-600 hover:bg-gray-50">Next</button>
          </div>
        </div> -->
      </div>

    </main>
    <!-- Footer -->

  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      showMobileMenu: false,
      properties: [
        {
          id: 1,
          title: 'Luxury Penthouse with Ocean View',
          location: 'Miami Beach, FL',
          image: 'https://ai-public.mastergo.com/ai/img_res/93b91322b662093d4a70be301db7e9dc.jpg',
          status: 'Live',
          beds: 4,
          baths: 3.5,
          sqft: '3,200 sq.ft',
          startingBid: '2,500,000',
          auctionDate: 'Ends in 2 days'
        },
        {
          id: 2,
          title: 'Contemporary Downtown Loft',
          location: 'Chicago, IL',
          image: 'https://ai-public.mastergo.com/ai/img_res/d45050ad95a3479c87d1456a24c2cfbd.jpg',
          status: 'Upcoming',
          beds: 2,
          baths: 2,
          sqft: '1,800 sq.ft',
          startingBid: '850,000',
          auctionDate: 'Starts Jun 15'
        },
        {
          id: 3,
          title: 'Mediterranean Villa Estate',
          location: 'Beverly Hills, CA',
          image: 'https://ai-public.mastergo.com/ai/img_res/84f20261dc30ce55eb267edc25112837.jpg',
          status: 'Live',
          beds: 6,
          baths: 7,
          sqft: '6,500 sq.ft',
          startingBid: '4,900,000',
          auctionDate: 'Ends in 5 days'
        },
        {
          id: 4,
          title: 'Waterfront Modern Mansion',
          location: 'Seattle, WA',
          image: 'https://ai-public.mastergo.com/ai/img_res/848f368d34f65aad93f40c9529c7e2d5.jpg',
          status: 'Upcoming',
          beds: 5,
          baths: 6,
          sqft: '5,800 sq.ft',
          startingBid: '3,750,000',
          auctionDate: 'Starts Jun 20'
        },
        {
          id: 5,
          title: 'Historic Brownstone',
          location: 'Boston, MA',
          image: 'https://ai-public.mastergo.com/ai/img_res/6936c5aa82c6cfa569f7356d39913ca7.jpg',
          status: 'Live',
          beds: 4,
          baths: 3.5,
          sqft: '3,600 sq.ft',
          startingBid: '2,200,000',
          auctionDate: 'Ends in 3 days'
        },
        {
          id: 6,
          title: 'Mountain View Ranch',
          location: 'Aspen, CO',
          image: 'https://ai-public.mastergo.com/ai/img_res/67a445c2b215a9e28ccf79608a4a108d.jpg',
          status: 'Upcoming',
          beds: 5,
          baths: 4,
          sqft: '4,200 sq.ft',
          startingBid: '3,200,000',
          auctionDate: 'Starts Jun 25'
        }
      ]
    };
  }
};
</script>
<style scoped></style>